import { useBusinessEntity } from '@zenbusiness/application-commons-business-entity';
import { useExperimentFlagDetail } from '@zenbusiness/application-commons-experiments';
import { gql, useQuery } from '@zenbusiness/application-commons-graphql';
import { useError } from '@zenbusiness/application-commons-logging';

import { WFC_PAST_DUE_BANNER_CTA_EXPERIMENT } from '#client/constants/experimentsFlags';

export const BANNERS_QUERY = gql`
  query Banners($businessEntityUuid: UUID!, $wfcPastDueBannerCtaExperiment: String) {
    banners(
      filter: {
        businessEntityUuid: $businessEntityUuid
        experiment: { wfcPastDueBannerCtaExperiment: $wfcPastDueBannerCtaExperiment }
      }
    ) {
      title
      description
      type
      imageUrl
      imageSize
      raised
      dismissible
      storageKey
      experiment {
        featureFlagKey
        featureFlagVariation
      }
      primaryCta {
        label
        modalName
        url
      }
      secondaryCta {
        label
        modalName
        url
      }
    }
  }
`;

export function useBanners() {
  const { businessEntityUuid } = useBusinessEntity();
  const { value: wfcPastDueBannerCtaExperiment, reason } = useExperimentFlagDetail(
    WFC_PAST_DUE_BANNER_CTA_EXPERIMENT,
    null,
  );

  const { data, loading, error } = useQuery(BANNERS_QUERY, {
    noThrow: true,
    variables: {
      businessEntityUuid,
      wfcPastDueBannerCtaExperiment,
    },
  });

  useError(error);

  return {
    data: data?.banners || [],
    error,
    inWfcPastDueBannerCtaExperiment: reason?.inExperiment ?? false,
    loading,
  };
}
